import Constants from '../constants';
const constants = Constants
export const CloseDrawer=() => {
    return { type: constants.Actions.Menu.CloseDrawer };
}
export const OpenDrawer = () => {
    return { type: constants.Actions.Menu.OpenDrawer };
}